export default {"src":"/_next/static/media/share-orange.805edba7.svg","height":32,"width":32};